import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivationCodeModalComponent } from '../app/modals/activation-code-modal/activation-code-modal.component';
import { WhereToFindImeiModalComponent } from '../app/modals/where-to-find-imei-modal/where-to-find-imei-modal.component';
import { ModalFailureComponent } from '../app/modals/modal-failure/modal-failure.component';
import { ModalSuccessComponent } from '../app/modals/modal-success/modal-success.component';
import { AccountPinRetrievalComponent } from '../app/modals/account-pin-retrieval/account-pin-retrieval.component';
import { ChangeNameModalComponent, ChangeNameModalData } from '../app/modals/change-name-modal/change-name-modal.component';
import { ChangeEmailModalComponent, ChangeEmailModalData } from '../app/modals/change-email-modal/change-email-modal.component';
import { ChangePasswordModalComponent, ChangePasswordModalData } from '../app/modals/change-password-modal/change-password-modal.component';
import { ModalSuccessData } from '../app/modals/modal-success/modal-success.component';
import { ModalFailureData } from '../app/modals/modal-failure/modal-failure.component';
import { AddActivatedNumberModalComponent } from '../app/modals/add-activated-number-modal/add-activated-number-modal.component';
import { AlertSecurityModalComponent } from '../app/modals/alert-security-modal/alert-security-modal.component';
import { CheckAccountBalanceModalComponent, CheckAccountBalanceModalData } from '../app/modals/check-account-balance-modal/check-account-balance-modal.component';
import { TopupModalComponent, TopupModalData } from '../app/modals/topup-modal/topup-modal.component';
import { emailVerificationModalComponent } from '../app/modals/email-verification-needed-modal/email-verification-needed-modal.component';
import { PaymentsModalComponent } from '../app/modals/payments-modal/payments-modal.component';
import { ChangePlanModalComponent, ChangePlanModalData } from '../app/modals/change-plan-modal/change-plan-modal.component';
import { AutoRenewalModalComponent } from '../app/modals/auto-renewal-modal/auto-renewal-modal.component';
import { AutoPayModalComponent } from '../app/modals/auto-pay-modal/auto-pay-modal.component';
import { SelectProvinceModalComponent } from '../app/modals/select-province-modal/select-province-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private dialog = inject(MatDialog);

  closeAll(): void {
    this.dialog.closeAll();
  }

  public showActivationCodeModalComponent(): MatDialogRef<any> {
    return this.dialog.open(ActivationCodeModalComponent, {
      disableClose: false,
      autoFocus: false
    });
  }

  public showIMEIModalComponent(): MatDialogRef<any> {
    return this.dialog.open(WhereToFindImeiModalComponent, {
      disableClose: false,
      autoFocus: false
    });
  }


  public showGetPinModalComponent(mdn: string): MatDialogRef<any> {
    return this.dialog.open(AccountPinRetrievalComponent, {
      disableClose: false,
      autoFocus: false, data: {
        mdn
      }
    });
  }

  public successModal(data: ModalSuccessData): MatDialogRef<ModalSuccessComponent> {
    return this.dialog.open(ModalSuccessComponent, {
      disableClose: false,
      autoFocus: false,
      data,
    });
  }

  public failureModal(data: ModalFailureData): MatDialogRef<ModalFailureComponent> {
    return this.dialog.open(ModalFailureComponent, {
      disableClose: false,
      autoFocus: false,
      data,
    });
  }

  public showChangeNameModal(data: ChangeNameModalData): MatDialogRef<ChangeNameModalComponent> {
    return this.dialog.open(ChangeNameModalComponent, {
      disableClose: false,
      autoFocus: false,
      data,
    });
  }

  public showChangePasswordModal(data: ChangePasswordModalData): MatDialogRef<ChangePasswordModalComponent> {
    return this.dialog.open(ChangePasswordModalComponent, {
      disableClose: false,
      autoFocus: false,
      data,
    });
  }

  public showChangeEmailModal(data: ChangeEmailModalData): MatDialogRef<ChangeEmailModalComponent> {
    return this.dialog.open(ChangeEmailModalComponent, {
      disableClose: false,
      autoFocus: false,
      data,
    });
  }

  public showAddActivatedNumberModal(): MatDialogRef<any> {
    return this.dialog.open(AddActivatedNumberModalComponent, {
      disableClose: false,
      autoFocus: false
    });
  }
  public showPaymentsModal(data?: any): MatDialogRef<any> {
    return this.dialog.open(PaymentsModalComponent, {
      disableClose: false,
      autoFocus: false,
      data
    });
  }

  public showAlertSecurityModal(
    title: string,
    primaryText: string,
    secondaryText: string,
    customHTML: string,
    timer: boolean = false,
  ): MatDialogRef<any> {
    return this.dialog.open(AlertSecurityModalComponent, {
      disableClose: true,
      autoFocus: false,
      data: { title, primaryText, secondaryText, customHTML, timer }
    });
  }

  public showCheckAccountBalanceModal(data?: CheckAccountBalanceModalData): MatDialogRef<CheckAccountBalanceModalComponent> {
    return this.dialog.open(CheckAccountBalanceModalComponent, {
      disableClose: false,
      autoFocus: false,
      data
    });
  }
  public showTopupModal(data?: TopupModalData): MatDialogRef<TopupModalComponent> {
    return this.dialog.open(TopupModalComponent, {
      disableClose: false,
      autoFocus: false,
      data
    });
  }

  public showChangePlanModal(data?: ChangePlanModalData): MatDialogRef<ChangePlanModalComponent> {
    return this.dialog.open(ChangePlanModalComponent, {
      disableClose: false,
      autoFocus: false,
      data
    });
  }
  public showEmailVerificationNeededModal(email) : MatDialogRef<emailVerificationModalComponent> {
    return this.dialog.open(emailVerificationModalComponent, {
      disableClose: true,
      data: {
        email
      }
    });
  }
  public disableAutoRenewModal(): MatDialogRef<any> {
    return this.dialog.open(AutoRenewalModalComponent, {
      disableClose: false,
      autoFocus: false
    });
  }
  public showAutoPayModal(data): MatDialogRef<any> {
    return this.dialog.open(AutoPayModalComponent, {
      disableClose: false,
      autoFocus: false,
      data
    });
  }

  public showProvinceeModal(): MatDialogRef<any> {
     return this.dialog.open(SelectProvinceModalComponent, {
      disableClose: false,
      autoFocus: false
    });
  }
}
